import { render, staticRenderFns } from "./p1s2Reporting.vue?vue&type=template&id=53b4e440&scoped=true"
import script from "./p1s2Reporting.vue?vue&type=script&lang=js"
export * from "./p1s2Reporting.vue?vue&type=script&lang=js"
import style0 from "./p1s2Reporting.vue?vue&type=style&index=0&id=53b4e440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b4e440",
  null
  
)

export default component.exports